var map = {
	"./shape-triangle-aquamarine-gradient.png": 13504,
	"./shape-triangle-aquamarine-light.png": 82685,
	"./shape-triangle-aquamarine.png": 5442,
	"./shape-triangle-blue-gradient.png": 70891,
	"./shape-triangle-blue-light.png": 89873,
	"./shape-triangle-blue.png": 50403,
	"./shape-triangle-cyan-gradient.png": 92560,
	"./shape-triangle-cyan-light.png": 73961,
	"./shape-triangle-cyan.png": 88103,
	"./shape-triangle-green-gradient.png": 52548,
	"./shape-triangle-green-light.png": 76148,
	"./shape-triangle-green.png": 95616,
	"./shape-triangle-grey100.png": 22329,
	"./shape-triangle-grey1000.png": 39124,
	"./shape-triangle-grey200.png": 12702,
	"./shape-triangle-grey25.png": 59218,
	"./shape-triangle-grey300.png": 99559,
	"./shape-triangle-grey400.png": 27742,
	"./shape-triangle-grey50.png": 28916,
	"./shape-triangle-grey500.png": 11551,
	"./shape-triangle-grey600.png": 11937,
	"./shape-triangle-grey700.png": 9463,
	"./shape-triangle-grey800.png": 44304,
	"./shape-triangle-grey900.png": 64183,
	"./shape-triangle-indigo-gradient.png": 19530,
	"./shape-triangle-indigo-light.png": 7410,
	"./shape-triangle-indigo.png": 85360,
	"./shape-triangle-lime-gradient.png": 60033,
	"./shape-triangle-lime-light.png": 78515,
	"./shape-triangle-lime.png": 41502,
	"./shape-triangle-magenta-gradient.png": 62976,
	"./shape-triangle-magenta-light.png": 18728,
	"./shape-triangle-magenta.png": 36018,
	"./shape-triangle-navy-gradient.png": 79018,
	"./shape-triangle-navy-light.png": 61979,
	"./shape-triangle-navy.png": 53798,
	"./shape-triangle-orange-gradient.png": 65466,
	"./shape-triangle-orange-light.png": 17707,
	"./shape-triangle-orange.png": 23362,
	"./shape-triangle-purple-gradient.png": 87954,
	"./shape-triangle-purple-light.png": 70152,
	"./shape-triangle-purple.png": 50838,
	"./shape-triangle-red-gradient.png": 60234,
	"./shape-triangle-red-light.png": 17461,
	"./shape-triangle-red.png": 98573,
	"./shape-triangle-yellow-gradient.png": 15029,
	"./shape-triangle-yellow-light.png": 39801,
	"./shape-triangle-yellow.png": 15630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45866;